import HTTP from '@/config/axios-config-erp'

const ServiceTratamientos = {
  getTratamientos(payload) {
    return HTTP.post(`/wscomun/portalinformes/ContratoCab`, payload).then(response => {
      return response
    }).catch(error => {
      console.log(error.response)
      return { 'status': 500 }
    })
  },
  getDetTratamientos(payload) {
    return HTTP.post(`/wscomun/portalinformes/contratoDet`, payload).then(response => {
      return response
    }).catch(error => {
      console.log(error.response)
      return { 'status': 500 }
    })
  },
  getImprimirContrat(payload) {
    return HTTP.post(`/wscomun/portalinformes/imprimirContrato`, payload).then(response => {
      return response
    }).catch(error => {
      console.log(error.response)
      return { 'status': 500 }
    })
  }
}

export default ServiceTratamientos



// WEBPACK FOOTER //
// ./src/services/srv-tratamientos.js